
import React, { memo, useEffect, useState } from 'react'
import CustomPressable from '../customPressable/customPressable';
import { View } from 'react-native';
import { ImageComp } from '../Image/Image';
import CustomFlatList from '../customFlatList';
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl } from '../../utils/Helper';
import useWidgetClickHandler from '../../customHook/useWidgetClickHandler';
import { chatKeys, doorKey } from '../../config/Constant';
import { useNavigation } from '@react-navigation/native';
import { DOOR_KEY_FLOW } from '../../navigation/StackNavigator/routes';
import { setShowOfflineMessage } from '../../Redux/Reducers/appConfigReducer';
import { useDispatch, useSelector } from 'react-redux';
import { handleOpenChat } from '../../Apps/chat/initializeChat';

const FloatingWidget = memo((props) => {

  const dispatch = useDispatch();

  const { listItemData } = props || {};
  const handleOnWidgetClick = useWidgetClickHandler();
  const getStyles = useCssStyle();
  const navigation = useNavigation();

  const { isOnline } = useSelector(state => state.appConfigSlice);


  const handleFloatingWidgetClick = (item) => {

    if (!item) {
      return;
    }

    if (chatKeys.includes(item.widgetTypeName?.toLowerCase())) {

      if (!isOnline) {
        dispatch(setShowOfflineMessage(true));
        return;
      }
      dispatch(handleOpenChat());
      return;
    }

    if (doorKey.includes(item.widgetTypeName?.toLowerCase())) {
      if (!isOnline) {
        dispatch(setShowOfflineMessage(true));
        return;
      }
      navigation.navigate(DOOR_KEY_FLOW)
      return;
    }

    handleOnWidgetClick(item)
  }


  const renderItem = ({ item }) => (
    <CustomPressable onPress={() => handleFloatingWidgetClick(item)} style={getStyles(['floatingWidgetsWidgetContainer', `floatingWidgetsWidgetContainer_${item.widgetMetaHtmlId}`, `floatingWidgetsWidgetContainer_${item.id}`])} id={`floatingWidgetsWidgetContainer floatingWidgetsWidgetContainer_${item.widgetMetaHtmlId} floatingWidgetsWidgetContainer_${item.id}`} >

      <View style={getStyles(['floatingWidgetImageStyle', `floatingWidgetImageStyle_${item.widgetMetaHtmlId}`, `floatingWidgetImageStyle_${item.id}`])} id={`floatingWidgetImageStyle floatingWidgetImageStyle_${item.widgetMetaHtmlId} floatingWidgetImageStyle_${item.id}`}>
        <ImageComp
          source={getCleanUrl(item?.btnImageUrl)}
          style={getStyles(['floatingWidgetImage', `floatingWidgetImage_${item.widgetMetaHtmlId}`, `floatingWidgetImage_${item.id}`])}
          id={`floatingWidgetImage floatingWidgetImage_${item.widgetMetaHtmlId} floatingWidgetImage_${item.id}`}
        />
      </View>
    </CustomPressable>
  );


  return (
    <View style={getStyles(['floatingWidgetMainContainer', `floatingWidgetMainContainer_${listItemData[0]?.widgetMetaHtmlId}`])} id={`floatingWidgetMainContainer floatingWidgetMainContainer_${listItemData[0]?.widgetMetaHtmlId}`}>
      <CustomFlatList
        nestedScrollEnabled={true}
        data={listItemData}
        renderItem={renderItem}
        keyExtractor={item => item?.widgetId?.toString()}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={getStyles(['floatingWidgetFlatListContentContainer'])}
      />
    </View>
  );
})

export default FloatingWidget